import React from "react"

interface BuilderQueryPreviewProps {
  script: string
  isIncomplete: boolean
}

/**
 * Read-only preview of the script the Builder will run. Always visible —
 * the design promise is "you can see exactly what it's doing", so this is
 * not behind a "show source" affordance.
 */
const BuilderQueryPreview: React.FC<BuilderQueryPreviewProps> = ({
  script,
  isIncomplete,
}) => {
  return (
    <div className="qc-preview">
      <div className="qc-preview__header">
        <span className="qc-preview__title">Generated query</span>
        {isIncomplete && (
          <span className="qc-preview__hint">
            Add at least one row and one column variable
          </span>
        )}
      </div>
      <pre className="qc-preview__body qc-mono" aria-readonly="true">
        {isIncomplete ? "" : script}
      </pre>
    </div>
  )
}

export default BuilderQueryPreview
